/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} World_Switcher_SwitchingInputs */

const en_world_switcher_switching = /** @type {(inputs: World_Switcher_SwitchingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Switching to ${i?.target}`)
};

const fr_world_switcher_switching = /** @type {(inputs: World_Switcher_SwitchingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bascule vers ${i?.target}`)
};

const ms_sg2_world_switcher_switching = /** @type {(inputs: World_Switcher_SwitchingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bertukar ke ${i?.target}`)
};

/**
* | output |
* | --- |
* | "Switching to {target}" |
*
* @param {World_Switcher_SwitchingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const world_switcher_switching = /** @type {((inputs: World_Switcher_SwitchingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<World_Switcher_SwitchingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_world_switcher_switching(inputs)
	if (locale === "fr") return fr_world_switcher_switching(inputs)
	return ms_sg2_world_switcher_switching(inputs)
});